import React, { useState } from "react";

// Custom Components
import Filter from "@Components/Filter";
import Table from "@Components/Table";

import {
  ESTATE_FETCH_URL,
  ESTATE_QR_DOWNLOAD_URL,
  ESTATE_QR_PRINT_URL,
  REGION_FETCH_URL,
  ZONE_FETCH_URL,
} from "configs/constants";
import axios from "axios";
import Notify from "@Components/Notify";
import { COMPANY_FETCH_URL } from "configs/constants";

const today = new Date();
const pageNumberDropdown = true;



let model = [
  { id: "company_name", label: "Company", type: "string" },
  { id: "zone_code", label: "Zone Code", type: "string" },
  { id: "zone_name", label: "Zone Name", type: "string" },
  { id: "region_code", label: "Region Code", type: "string" },
  { id: "region_name", label: "Region Name", type: "string" },
  { id: "code", label: "Estate Code", type: "string" },
  { id: "name", label: "Estate Name", type: "string" },
];

const actions = ["view"];

const FileDownload = require("js-file-download");

export default function EstateQRList() {
  
  const [filterValues, setFilterValues] = useState({});
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const [selected, setSelected] = useState([]);
  // allChecked is a state for table header, used to check all
  const [allChecked, setAllChecked] = useState(false);
  const filterInitialValues = {
    zone: "",
    region: "",
    estate: "",
  };
  const API_VERSION = "v1";
  const API_URL = process.env.REACT_APP_API_URL;
  let baseURL = `${API_URL}${API_VERSION}/`;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const getZoneValues = (e,setDisableRegion) => {
    if (!e || e.length === 0) {
      setDisableRegion(true);
    }
    else {
      setDisableRegion(false);
    }
    
  };
  const getRegionValues = (e,setDisableEstate) => {
    if (!e || e.length === 0) {
      setDisableEstate(true);
    }
    else {
      setDisableEstate(false);
    }
    
  };
  const actionBarButtons = [
    {
      color: "Primary",
      buttonLabel: "Download QR Code",
      onClick: () => {
        if (selected.length < 1) {
          setNotify({
            isOpen: true,
            message: "Please select one or more estate to download QR",
            type: "error",
          });
        } else {
          const body = { ids: selected, ...filterValues };
          console.log("body", body);
          const url = baseURL + ESTATE_QR_DOWNLOAD_URL;
          const headers = {
            Authorization: `JWT ${localStorage.getItem("token")}`,
          };
          axios({
            url: url,
            method: "get",
            headers: headers,
            responseType: "blob",
            params: body,
          }).then(function (response) {
            let date =
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate();
            FileDownload(response.data, "Estate_QR_Code" + date + ".pdf");
          });
        }
      },
    },
    {
      color: "Primary",
      buttonLabel: "Print QR Code",
      onClick: () => {
        if (selected.length < 1) {
          setNotify({
            isOpen: true,
            message: "Please select one or more estate to print QR",
            type: "error",
          });
        } else {
          const body = { ids: selected, ...filterValues };
          console.log("body", body);
          const url = baseURL + ESTATE_QR_PRINT_URL;
          const headers = {
            Authorization: `JWT ${localStorage.getItem("token")}`,
          };
          axios({
            url: url,
            method: "get",
            headers: headers,
            params: body,
          }).then(function (response) {
            const url = response.data.file_path;
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
        }
      },
    },
  ];
  const getCompanyValues = (e, setDisableZone) => {
    if (!e || e.length === 0) {
      setDisableZone(true);
    }
    else {
      setDisableZone(false);
    }
  
  };
  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
    setSelected([]);
    setAllChecked(false);
  };
  const onclearFilter = () => {
    setSelected([]);
    setAllChecked(false);
  };
  const filterFields = [
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      required: true,
  
  
    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl: ESTATE_FETCH_URL, 
      paginated: false,
      isPaginationEnabled: false,
      isAllowablesEnabled: false,
      disabled:disableEstate,  
      optionsDependsOn: "region",
    },
  ];
  return (
    <div>
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
        onClear={onclearFilter}
      />

      <Table
        proxyURL={ESTATE_FETCH_URL}
        model={model}
        actions={actions}
        actionBarButtons={actionBarButtons}
        pageNumberDropdown={pageNumberDropdown}
        check
        // prop to get selected values
        selected={selected}
        // callback setter
        setSelected={setSelected}
        allChecked={allChecked}
        setAllChecked={setAllChecked}
        filterValues={filterValues}
        noFilter
        noAddButton
      />
      <Notify notify={notify} setNotify={setNotify} />
    </div>
  );
}
